exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1YRO4DwDuAvx0eclU94R2f {\n  outline: 0;\n  overflow: auto;\n  position: relative;\n}\n\n._1ivZTwowJMdKnXoTKvAg6D {\n  box-sizing: border-box;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n", ""]);

// exports
exports.locals = {
	"VirtualScroll": "_1YRO4DwDuAvx0eclU94R2f",
	"InnerScrollContainer": "_1ivZTwowJMdKnXoTKvAg6D"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./source/VirtualScroll/VirtualScroll.css
 ** module id = 22
 ** module chunks = 0
 **/